<angular-cropper #angularCropper [cropperOptions]="config" [imageUrl]="imgUrl"></angular-cropper>
